import React from "react";
import Text from "../components/typography/Text";
import Icon from "@mdi/react";
import { mdiFolderOpen } from "@mdi/js";

export default () => (
  <div className="oNoItems">
    <div className="oNoItems_icon">
      <Icon path={mdiFolderOpen} size="34px" color="#949494" />
    </div>
    <div className="oNoItems_text">
      <h4>No results found</h4>
      <Text small>Come back soon or try another filter</Text>
    </div>
  </div>
);
